import { apiClient } from './client';
import type { Address } from '../types';

interface CreateAddressData {
  address_line: string;
  city: string;
  postal_code: string;
  notes?: string;
  is_default?: boolean;
}

export const addressesApi = {
  // Get all addresses
  getAddresses: () => apiClient.get<{ addresses: Address[] }>('/customers/me/addresses'),

  // Create address
  createAddress: (data: CreateAddressData) =>
    apiClient.post<Address>('/customers/me/addresses', data),

  // Update address
  updateAddress: (id: number, data: CreateAddressData) =>
    apiClient.put<Address>(`/customers/me/addresses/${id}`, data),

  // Delete address
  deleteAddress: (id: number) =>
    apiClient.delete<{ message: string }>(`/customers/me/addresses/${id}`),
};
